var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWIllness2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_11527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2487 33.5H28.582V41.6667H33.2487V33.5Z",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 41.0835L43.75 43.4168L55.4167 37.5835V35.8335L47.25 37.5835",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 34.0835H37.9167L42.5833 36.4168H47.25V38.7502L42 39.3335L37.9167 38.1668",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.918 38.75V39.9167",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.166 28.8335C43.166 29.8018 43.9477 30.5835 44.916 30.5835C45.8843 30.5835 46.666 29.8018 46.666 28.8335C46.666 27.8652 45.8843 27.0835 44.916 27.0835C43.9477 27.0835 43.166 26.3018 43.166 25.3335C43.166 24.3652 43.9477 23.5835 44.916 23.5835C45.8843 23.5835 46.666 24.3652 46.666 25.3335",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.916 30.5835V32.3335",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.916 21.8335V23.5835",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9167 33.4998C48.4605 33.4998 51.3333 30.627 51.3333 27.0832C51.3333 23.5393 48.4605 20.6665 44.9167 20.6665C41.3728 20.6665 38.5 23.5393 38.5 27.0832C38.5 30.627 41.3728 33.4998 44.9167 33.4998Z",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.332 27.0835H55.4154",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5013 27.0835H34.418",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.918 33.5V35.8333",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.918 20.6668V16.5835",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4551 22.5452L52.3426 19.6577",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3796 31.6216L37.918 34.0832",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4563 31.6218L52.3438 34.5093C54.2455 32.6077 55.418 29.9827 55.418 27.0835C55.418 21.2852 50.7163 16.5835 44.918 16.5835C39.1196 16.5835 34.418 21.2852 34.418 27.0835C34.418 29.2418 35.0713 31.2485 36.1855 32.9168",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3777 22.5452L37.4902 19.6577",
    stroke: "#0D4248",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_11527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(28 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWIllness2);
export default __webpack_public_path__ + "static/media/w-illness2.738e9226f7947b3bdb4ad6eee4dbf771.svg";
export { ForwardRef as ReactComponent };